import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";


interface Props {
  onTapCloseModal: () => void;
}

// ログイン画面で利用している「パスワードを忘れた方、お困りの方はこちら」モーダル
export const ReauthorizationCompleted = ({ onTapCloseModal }: Props) => {

  return (
    <BasePageModal
      title="再認可完了"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="閉じる"
          onClick={onTapCloseModal}
        />
      }
    >
      <p>
        再認可が完了しました
      </p>
    </BasePageModal>
  );
};
